import {
  Component,
  OnInit,
  Input,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { InvalidControlScrollDirective } from "../ng-invalid-control-scroll-wt-directive.directive";
import { CommonService } from "src/app/common.service";
import {
  FormGroup,
  FormControl,
  Validators,
  FormBuilder,
} from "@angular/forms";
import {
  InlineResponse200,
  Profile,
  Base64Document,
  PaymentMethod,
  Specialization,
  Reference,
  Certification,
  Certificate,
} from "profile-api";
import { AlmostOneRequired } from "../utils/almost-one-required.validator";

class Document {
  document?: Base64Document;
  message: string;
  buttonClass: string;
}

class SpecializationUM {
  specialization: Specialization;
  um: string;
  errorMessage: string;
}

class Refer {
  reference: Reference;
  errorMessage: string;
}

class Certif {
  certification: Certification;
  errorMessage: string;
}

class CertificatesItem {
  certificate: Certificate;
  errorMessage: string;
}

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.css"],
})
export class ProfileComponent implements OnInit {
  @Input("tenderId") tenderId: number;
  @Input("fromTender") fromTender: boolean;
  @Input("fromClusterTender") fromClusterTender: boolean;
  @Input("fromRestrictedArea") fromRestrictedArea: boolean;
  @Input("fromPrepaidPacketBuy") fromPrepaidPacketBuy: boolean;
  @Input("fromQuoteBuy") fromQuoteBuy: boolean;
  @Input("fromPrepaidPacket") fromPrepaidPacket: boolean;
  @Input("returnResource") returnResource: string;

  @ViewChild("checkDesigner") checkDesigner: ElementRef;
  professionalRegistryList = null;
  ////////////////////
  showhidedesigner: boolean = false;
  typeCompanyList = null;
  sectorCompanyList = null;
  typeProfessionalList = null;
  sectorProfessionalList = null;
  companySizeList = null; //vale sia per "impresa" che per "professionisti"
  references: Array<Refer> = [];
  referenceType = null;
  certifications: Array<Certif> = [];
  certificationType = null;

  userCompany: boolean = null;
  certificates: Array<CertificatesItem> = [];

  addReferenceButtonVisible: boolean = true;
  addCertificationButtonVisible: boolean = true;
  addSectorButtonVisible: boolean = true;
  ////////////////////
  error = "no_error";
  provinces = null;
  loading = false;
  logo: Document = { document: null, message: "no_message", buttonClass: "" };
  visura: Document = { document: null, message: "no_message", buttonClass: "" };
  durc: Document = { document: null, message: "no_message", buttonClass: "" };
  errorMessageClass: string = "alert";
  specializationsCompanyList = null;
  specializationsProfessionalList = null;
  specializations: Array<SpecializationUM> = [];
  specUM: string;
  addSpecializationButtonVisible: boolean = true;
  sectorCodes = new Array();
  dropdownSettings = {};
  sectorCodeMessage: string = "no_error";
  sectorCodesMessage: string = "no_error";
  specializationMessage: string = "no_error";

  profileForm: FormGroup;

  privateRegistry: boolean = false;

  constructor(
    private commonService: CommonService,
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private cd: ChangeDetectorRef,
    private invalidControlScrollDirective: InvalidControlScrollDirective,
    private el: ElementRef
  ) {}

  ngOnInit() {
    // this.default = { ...this._defaultValue, ...this.default };
    this.createDefaultForm();

    // //////////////////////////////////
    //typeCompanyList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("TYPE_COMPANY")
      .subscribe(
        (data) => {
          this.typeCompanyList = data.items;
          this.typeCompanyList = this.typeCompanyList.filter(
            (type) => type.code != "N.D."
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista dei tipi di impresa.";
          console.log(error);
        }
      );
    //sectorCompanyList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SECTOR_COMPANY")
      .subscribe(
        (data) => {
          this.sectorCompanyList = data.items;
          this.sectorCompanyList = this.sectorCompanyList.filter(
            (sector) => sector.code != "N.D."
          );
        },
        (error) => {
          this.error = "Impossibile caricare la lista dei settori di impresa.";
          console.log(error);
        }
      );
    //typeProfessionalList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("TYPE_PROFESSIONAL")
      .subscribe(
        (data) => {
          this.typeProfessionalList = data.items;
        },
        (error) => {
          this.error = "Impossibile caricare la lista dei tipi di società.";
          console.log(error);
        }
      );
    //sectorProfessionalList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SECTOR_PROFESSIONAL")
      .subscribe(
        (data) => {
          this.sectorProfessionalList = data.items;
          this.sectorProfessionalList = this.sectorProfessionalList.filter(
            (sector) => sector.code != "N.D."
          );
        },
        (error) => {
          this.error =
            "Impossibile caricare la lista di settori dei professionisti.";
          console.log(error);
        }
      );
    //companySizeList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SIZE_COMPANY")
      .subscribe(
        (data) => {
          this.companySizeList = data.items;
        },
        (error) => {
          this.error =
            "Impossibile caricare la lista del numero di dipendenti.";
          console.log(error);
        }
      );
    // //////////////////////////////////

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("PROFESSIONAL_REGISTRY")
      .subscribe(
        (data) => {
          this.professionalRegistryList = data.items;
        },
        (error) => {
          this.error = "Impossibile caricare la lista degli albo.";
          console.log(error);
        }
      );

    this.commonService
      .getProvinces()
      .then((provinceList: InlineResponse200) => {
        this.provinces = provinceList;
        this.provinces = this.provinces.filter(
          (province) => province.code != "N.D."
        );
      })
      .catch((error) => {
        this.error = "Impossibile caricare la lista delle province.";
        console.log(error);
      });

    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SPECIALIZATION")
      .subscribe(
        (data) => {
          this.specializationsCompanyList = data.items;
          this.specializationsCompanyList =
            this.specializationsCompanyList.filter(
              (sector) => sector.code != "N.D."
            );

          this.commonService.getProfile().then((profile: Profile) => {
            this.setProfileType(profile);
            this.profileForm.reset(profile);
            this.loadSectors(profile);
            this.loadSpecializations(profile);
            this.loadReferences(profile);
            this.loadCertifications(profile);
            this.loadCertificates(profile);
            this.loadDocuments(profile);
          });
        },
        (error) => {
          this.error = "Impossibile caricare la lista delle specializzazioni.";
          console.log(error);
        }
      );

    //typeProfessionalList
    this.commonService
      .getStandardService()
      .stdSystemListsListNameGet("SPECIALIZATION_PROFESSIONAL")
      .subscribe(
        (data) => {
          this.specializationsProfessionalList = data.items;
          this.specializationsProfessionalList =
            this.specializationsProfessionalList.filter(
              (sector) => sector.code != "N.D."
            );
        },
        (error) => {
          this.error = "Impossibile caricare la lista dei tipi di società.";
          console.log(error);
        }
      );

    this.dropdownSettings = {
      singleSelection: false,
      idField: "code",
      textField: "description",
      selectAllText: "Seleziona tutti",
      unSelectAllText: "Deseleziona tutti",
      itemsShowLimit: 20,
      allowSearchFilter: true,
    };
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe((params) => {
      this.fromTender = params["fromTender"];
      this.fromClusterTender = params["fromClusterTender"];
      this.fromRestrictedArea = params["fromRestrictedArea"];
      this.fromPrepaidPacketBuy = params["fromPrepaidPacketBuy"];
      this.fromQuoteBuy = params["fromQuoteBuy"];
      this.fromPrepaidPacket = params["fromPrepaidPacket"];
      this.returnResource = params["returnResource"];
    });

    console.log("Profile ngOnInit ");

    if (
      this.fromTender ||
      this.fromClusterTender ||
      this.fromRestrictedArea ||
      this.fromPrepaidPacketBuy ||
      this.fromQuoteBuy ||
      this.fromPrepaidPacket
    ) {
      this.cd.detectChanges();
      let that = this;
      setTimeout(function () {
        const controls = that.profileForm.controls;
        Object.keys(controls).forEach((controlName) =>
          controls[controlName].markAsDirty()
        );
        that.profileSubmitHandler();
        that.scrollToFirstInvalidControl();
      }, 2000);
    }
  }

  isProfileValid(): boolean {
    // name, surname, email, phone
    if (
      this.profileForm.get("firstName").valid &&
      this.profileForm.get("lastName").valid &&
      this.profileForm.get("email").valid &&
      this.profileForm.get("phone").valid
    ) {
      return true;
    } else {
      return false;
    }
  }

  createDefaultForm() {
    this.profileForm = this.formBuilder.group(
      {
        firstName: new FormControl("", [Validators.required]),
        email: new FormControl("", [Validators.required]),
        lastName: new FormControl("", [Validators.required]),
        phone: new FormControl("", [Validators.required]),
        registrySubscriptionCode: new FormControl(null),
        registrySubscriptionProvince: new FormControl(null),
        registrySubscriptionNumber: new FormControl(null),
        employer: new FormControl(null),
        //////////////////
        typeCode: new FormControl(null, [Validators.required]),
        sectorCode: new FormControl(null),
        //registrySubscriptionTypeProfessional: new FormControl(null),
        //registrySubscriptionSectorProfessional: new FormControl(null),
        companySizeCode: new FormControl(null),
        generalContractor: new FormControl(null),
        sectorOrPartialContractor: new FormControl(null),
        //////////////////
        companyName: new FormControl("", [Validators.required]),
        vatCode: new FormControl(null),
        fiscalCode: new FormControl(null),
        pec: new FormControl("", [
          Validators.pattern(CommonService.EMAIL_REGEXP),
        ]),
        sdiCode: new FormControl(null),
        provinceCode: new FormControl("", [Validators.required]),
        city: new FormControl("", [Validators.required]),
        zipCode: new FormControl("", [Validators.required]),
        address: new FormControl("", [Validators.required]),
        addressNumber: new FormControl("", [Validators.required]),
        operationalCity: new FormControl("", [Validators.required]),
        operationalProvinceCode: new FormControl("", [Validators.required]),
        operationalZipCode: new FormControl("", [Validators.required]),
        operationalAddress: new FormControl("", [Validators.required]),
        operationalAddressNumber: new FormControl("", [Validators.required]),
        customerNotificationEnabled: new FormControl(null),
        designer: new FormControl(null),
      },
      {
        validator: [
          AlmostOneRequired("vatCode", "fiscalCode"),
          AlmostOneRequired("sdiCode", "pec"),
        ],
      }
    );
  }

  isBusinessValid() {
    // progettista: ragione sociale, partita iva, cf, pec, cod sdi, albo, provincia, n iscriz
    if (this.showhidedesigner) {
      if (
        this.profileForm.get("companyName").valid &&
        this.profileForm.get("vatCode").valid &&
        this.profileForm.get("fiscalCode").valid &&
        this.profileForm.get("pec").valid &&
        this.profileForm.get("sdiCode").valid &&
        this.profileForm.get("registrySubscriptionCode").value != null &&
        this.profileForm.get("registrySubscriptionProvince").valid != null &&
        this.profileForm.get("registrySubscriptionNumber").valid
      ) {
        return true;
      }
    } else {
      if (
        this.profileForm.get("companyName").valid &&
        this.profileForm.get("vatCode").valid &&
        this.profileForm.get("fiscalCode").valid &&
        this.profileForm.get("pec").valid &&
        this.profileForm.get("sdiCode").valid
      ) {
        return true;
      }
    }

    return false;
  }

  isDetailSectorValid() {
    if (
      this.profileForm.get("employer").valid &&
      this.profileForm.get("companySizeCode").value != null &&
      this.profileForm.get("typeCode").value != null &&
      this.sectorCodes.length > 0 &&
      this.checkSectorsValidity()
    ) {
      return true;
    }
    return false;
  }

  checkSectorsValidity() {
    for (let sectorItemCode of this.sectorCodes) {
      if (sectorItemCode.sector == null || sectorItemCode.sector == undefined) {
        return false;
      }
    }

    return true;
  }

  isRegisteredOfficeValid() {
    if (
      this.profileForm.get("city").valid &&
      this.profileForm.get("provinceCode").valid &&
      this.profileForm.get("zipCode").valid &&
      this.profileForm.get("address").valid &&
      this.profileForm.get("addressNumber").valid
    ) {
      return true;
    }

    return false;
  }

  isHeadquarterValid() {
    if (
      this.profileForm.get("operationalCity").valid &&
      this.profileForm.get("operationalProvinceCode").valid &&
      this.profileForm.get("operationalZipCode").valid &&
      this.profileForm.get("operationalAddress").valid &&
      this.profileForm.get("operationalAddressNumber").valid
    ) {
      return true;
    }

    return false;
  }

  areAttachmentsValid() {
    if (
      this.logo?.document?.fileName &&
      this.durc?.document?.fileName &&
      this.visura?.document?.fileName
    ) {
      return true;
    }

    return false;
  }

  areCertificationsValid() {
    if (this.certifications.length > 0 && this.checkCertifications()) {
      return true;
    }
    return false;
  }

  checkCertifications() {
    for (let certificate of this.certifications) {
      if (
        certificate.certification.name == null ||
        certificate.certification.name == undefined
      ) {
        return false;
      }
    }
    return true;
  }

  areCertificatesValid() {
    if (this.certificates.length > 0 && this.checkCertificates()) {
      return true;
    }
    return false;
  }

  checkCertificates() {
    for (let certificate of this.certificates) {
      if (
        certificate.certificate.name == null ||
        certificate.certificate.name == undefined
      ) {
        return false;
      }
    }
    return true;
  }

  areSpecializationsValid() {
    if (this.specializations.length > 0 && this.checkSpecializations()) {
      return true;
    } else {
      return false;
    }
  }

  checkSpecializations() {
    for (let specialization of this.specializations) {
      if (this.showhidedesigner) {
        if (
          specialization.specialization.code == null ||
          specialization.specialization.code == undefined
        ) {
          return false;
        }
      } else {
        if (
          specialization.specialization.code == null ||
          specialization.specialization.code == undefined ||
          specialization.specialization.salesPrice == undefined ||
          specialization.specialization.salesPrice == null ||
          specialization.specialization.minAmount == null ||
          specialization.specialization.minAmount == undefined
        ) {
          return false;
        }
      }

      return true;
    }
  }

  closeAccordion(id: string) {
    let a = document.getElementById(id);
    a.click();
  }

  loadDocuments(profile: Profile) {
    this.logo.document = profile.logo;
    if (profile.logo && profile.logo.documentUrl) {
      this.logo.buttonClass = "";
    } else {
      this.logo.buttonClass = "-disabled";
    }
    this.visura.document = profile.visura;
    if (profile.visura && profile.visura.documentUrl) {
      this.visura.buttonClass = "";
    } else {
      this.visura.buttonClass = "-disabled";
    }
    this.durc.document = profile.durc;
    if (profile.durc && profile.durc.documentUrl) {
      this.durc.buttonClass = "";
    } else {
      this.durc.buttonClass = "-disabled";
    }
  }

  loadSectors(profile: Profile) {
    for (let i = 0; i < profile.sectorsCodes.length; ++i) {
      this.sectorCodes.push({ sector: profile.sectorsCodes[i] });
    }

    this.setSectorAddButtonVisibility();
  }

  loadSpecializations(profile: Profile) {
    if (!this.checkDesigner.nativeElement.checked) {
      this.specializations = profile.specializations.map((item) => ({
        specialization: item,
        um: this.specializationsCompanyList.filter(
          (item2) => item2.code === item.code
        )[0].measurementUnit,
        errorMessage: null,
      }));
    } else if (this.checkDesigner.nativeElement.checked) {
      this.specializations = profile.specializations.map((item) => ({
        specialization: item,
        um: this.specializationsProfessionalList.filter(
          (item2) => item2.code === item.code
        )[0].measurementUnit,
        errorMessage: null,
      }));
    }

    this.setSpecializationAddButtonVisibility();
  }

  loadReferences(profile: Profile) {
    this.references = profile.references.map((item) => ({
      reference: item,
      um: this.specializationsCompanyList.filter(
        (item2) => item2.name === item.name
      ).name,
      errorMessage: null,
    }));
    this.setReferenceAddButtonVisibility();
  }

  loadCertifications(profile: Profile) {
    this.certifications = profile.certifications.map((item) => ({
      certification: item,
      um: this.specializationsCompanyList.filter(
        (item2) => item2.name === item.name
      ).name,
      errorMessage: null,
    }));
  }

  loadCertificates(profile: Profile) {
    this.certificates = profile.certificates.map((item) => ({
      certificate: item,
      errorMessage: null,
    }));
  }

  /* getCorrectUrl(baseUrl: string) {
      let url = baseUrl;
      if (this.tenderId) {
        url += '&tenderId=' + this.tenderId;
      }
      return url;
    } */

  validateSalesPriceValue(specialization: SpecializationUM) {
    if (
      specialization.specialization.salesPrice !== null &&
      specialization.specialization.salesPrice !== undefined &&
      specialization.specialization.maxPrice !== null &&
      specialization.specialization.salesPrice >
        specialization.specialization.maxPrice
    ) {
      specialization.errorMessage =
        "ATTENZIONE: il prezzo è superiore a quello fornito nelle gare precedenti.";
    } else {
      this.resetSpecError(specialization);
    }
  }

  resetSpecError(specialization: SpecializationUM) {
    specialization.errorMessage = null;
    this.resetError();
  }

  vaidateSpecializations() {
    let isValid: boolean = true;
    let formValues = this.profileForm.getRawValue();

    let profile: Profile = formValues;
    this.specializations.forEach((element) => {
      if (!profile.designer) {
        if (
          element.specialization.salesPrice === null ||
          element.specialization.minAmount === null ||
          element.specialization.salesPrice === undefined ||
          element.specialization.minAmount === undefined ||
          !element.specialization.salesPrice ||
          !element.specialization.minAmount
        ) {
          console.log("Prezzo e quantità obbligatori");
          element.errorMessage =
            "E' obbligatorio inserire un prezzo e una quantità.";
          isValid = false;
        } else {
          this.resetSpecError(element);
        }
      } else {
        if (!element.specialization.code) {
          console.log("Tipo di sepcializzazione obbligatorio");
          element.errorMessage =
            "E' obbligatorio inserire il tipo di specializzazione.";
          isValid = false;
        } else {
          this.resetSpecError(element);
        }
      }
    });
    return isValid;
  }

  setMandatoryFieldsBeforeSave() {
    if (this.privateRegistry == true) {
      // // // this.changeFormValidatorsPrivateRegistry()

      this.profileForm.patchValue({ sdiCode: "0000000" });
      this.profileForm.patchValue({ city: "N.D." });
      this.profileForm.patchValue({ provinceCode: "N.D." });
      this.profileForm.patchValue({ zipCode: "N.D." });
      this.profileForm.patchValue({ address: "N.D." });
      this.profileForm.patchValue({ addressNumber: "N.D." });
      this.profileForm.patchValue({ operationalCity: "N.D." });
      this.profileForm.patchValue({ operationalProvinceCode: "N.D." });
      this.profileForm.patchValue({ operationalZipCode: "N.D." });
      this.profileForm.patchValue({ operationalAddress: "N.D." });
      this.profileForm.patchValue({ operationalAddressNumber: "N.D." });
      this.profileForm.patchValue({ sectorCode: "N.D." });
      this.profileForm.patchValue({ typeCode: "N.D." });
      // this.durc.document = null
      // this.logo.document = null
      // this.visura.document = null

      // TODO SETTORE IMPRESA E SPECIALIZZAZIONI

      this.sectorCodes = [{ sector: "N.D." }];

      let spec: Specialization = {
        code: "N.D.",
        salesPrice: 1000,
        minPrice: 10,
        maxPrice: 10000,
        minAmount: 4,
        notificationEnabled: true,
      };
      let specUM: SpecializationUM = {
        specialization: spec,
        um: "N.D.",
        errorMessage: null,
      };
      this.specializations = [specUM];
    }
  }

  resetFields() {
    this.profileForm.controls["companyName"].reset();
    this.profileForm.controls["vatCode"].reset();
    this.profileForm.controls["registrySubscriptionCode"].reset();
    this.profileForm.controls["registrySubscriptionProvince"].reset();
    this.profileForm.controls["registrySubscriptionNumber"].reset();
    this.profileForm.controls["employer"].reset();
    this.profileForm.controls["sectorCode"].reset();
    this.profileForm.controls["companySizeCode"].reset();
    this.profileForm.controls["fiscalCode"].reset();
    this.profileForm.controls["pec"].reset();
    this.profileForm.controls["sdiCode"].reset();
    this.profileForm.controls["provinceCode"].reset();
    this.profileForm.controls["city"].reset();
    this.profileForm.controls["zipCode"].reset();
    this.profileForm.controls["address"].reset();
    this.profileForm.controls["addressNumber"].reset();
    this.profileForm.controls["operationalCity"].reset();
    this.profileForm.controls["operationalProvinceCode"].reset();
    this.profileForm.controls["operationalZipCode"].reset();
    this.profileForm.controls["operationalAddress"].reset();
    this.profileForm.controls["operationalAddressNumber"].reset();

    this.specializations = [];
    this.sectorCodes = [];
  }

  profileSubmitHandler() {
    this.setMandatoryFieldsBeforeSave();
    this.loading = true;
    console.log(!this.profileForm.valid + "_" + !this.vaidateSpecializations());
    if (!this.profileForm.valid || !this.vaidateSpecializations()) {
      this.error = "I campi non sono compilati correttamente";
      const controls = this.profileForm.controls;
      Object.keys(controls).forEach((controlName) =>
        controls[controlName].markAsDirty()
      );
      console.log("Invalid profile form");
      this.loading = false;
      return;
    }
    console.log("Profile submit");
    let formValues = this.profileForm.getRawValue();

    let profile: Profile = formValues;

    profile.privateRegistry = this.privateRegistry;
    if (profile.privateRegistry == true) {
      profile.designer = false;
    }

    profile.logo = this.logo.document;
    profile.visura = this.visura.document;
    profile.durc = this.durc.document;

    //Specializations
    profile.specializations = this.specializations.map(
      (item) => item.specialization
    );
    //References
    profile.references = this.references.map((item) => item.reference);
    //Certifications
    profile.certifications = this.certifications.map(
      (item) => item.certification
    );

    // Certificates
    profile.certificates = this.certificates.map((item) => item.certificate);

    //Certifications
    profile.sectorsCodes = this.sectorCodes.map((item) => item.sector);

    this.resetError();
    this.logo.message = "no_message";
    this.visura.message = "no_message";
    this.durc.message = "no_message";

    if (profile.designer) {
      if (!profile.sectorCode) {
        const controls = this.profileForm.controls;
        this.loading = false;
        this.scrollToComponent("sectorCode");
        this.sectorCodeMessage = "Il titolo professionale è obbligatorio";
        return;
      } else {
        this.sectorCodeMessage = "no_error";
      }
    } else {
      if (!profile.sectorsCodes || profile.sectorsCodes.length == 0) {
        this.loading = false;
        this.scrollToComponent("sectorCodes");
        this.sectorCodesMessage =
          "Selezionare almeno un settore in cui l'impresa opera";
        return;
      } else {
        this.sectorCodesMessage = "no_error";
      }
    }

    if (!profile.specializations || profile.specializations.length == 0) {
      this.loading = false;
      this.scrollToComponent("specializations");
      this.specializationMessage = "Selezionare almeno una specializzazione";
      return;
    } else {
      this.specializationMessage = "no_error";
    }
    this.commonService
      .saveProfile(profile)
      .then((profile: Profile) => {
        this.loading = false;

        //refresh profile
        localStorage.setItem("PROFILE_DATE", new Date().toString());
        localStorage.setItem("PROFILE", JSON.stringify(profile));

        if (this.fromTender) {
          this.commonService
            .getPaymentMethodService()
            .profilePaymentMethodGet()
            .subscribe(
              (_paymentMethod: PaymentMethod) => {
                if (this.tenderId) {
                  this.router.navigate(["/acquistapartecipazioneallagara"], {
                    queryParams: { tenderId: this.tenderId },
                  });
                } else {
                  this.router.navigate(["/acquistacreazionegara"]);
                }
              },
              (_error) => {
                if (this.tenderId) {
                  this.router.navigate(["/areariservata"], {
                    queryParams: {
                      tabToLoad: "paymentMethod",
                      fromTender: "yes",
                      tenderId: this.tenderId,
                    },
                  });
                } else {
                  this.router.navigate(["/areariservata"], {
                    queryParams: {
                      tabToLoad: "paymentMethod",
                      fromTender: "yes",
                    },
                  });
                }
              }
            );
        } else if (this.fromClusterTender) {
          this.commonService
            .getPaymentMethodService()
            .profilePaymentMethodGet()
            .subscribe(
              (_paymentMethod: PaymentMethod) => {
                if (this.tenderId) {
                  this.router.navigate(["/acquistapartecipazioneallagara"], {
                    queryParams: { tenderId: this.tenderId },
                  });
                } else {
                  this.router.navigate(["/acquistacreazionegaracluster"]);
                }
              },
              (_error) => {
                if (this.tenderId) {
                  this.router.navigate(["/areariservata"], {
                    queryParams: {
                      tabToLoad: "paymentMethod",
                      fromClusterTender: "yes",
                      tenderId: this.tenderId,
                    },
                  });
                } else {
                  this.router.navigate(["/areariservata"], {
                    queryParams: {
                      tabToLoad: "paymentMethod",
                      fromClusterTender: "yes",
                    },
                  });
                }
              }
            );
        } else if (this.fromPrepaidPacketBuy) {
          this.commonService
            .getPaymentMethodService()
            .profilePaymentMethodGet()
            .subscribe(
              (_paymentMethod: PaymentMethod) => {
                this.router.navigate(["/acquistapacchetto"]);
              },
              (_error) => {
                this.router.navigate(["/areariservata"], {
                  queryParams: {
                    tabToLoad: "paymentMethod",
                    fromPrepaidPacketBuy: "yes",
                  },
                });
              }
            );
        } else if (this.fromQuoteBuy) {
          this.commonService
            .getPaymentMethodService()
            .profilePaymentMethodGet()
            .subscribe(
              (_paymentMethod: PaymentMethod) => {
                this.router.navigate(["/acquistarichiestapreventivo"]);
              },
              (_error) => {
                this.router.navigate(["/areariservata"], {
                  queryParams: {
                    tabToLoad: "paymentMethod",
                    fromQuoteBuy: "yes",
                  },
                });
              }
            );
        } else if (this.fromPrepaidPacket) {
          this.router.navigate(["/areariservata"], {
            queryParams: { tabToLoad: "prepaidPackets" },
          });
        } else if (this.fromRestrictedArea) {
          window.location.href = this.returnResource;
        } else {
          this.error = "Profilo salvato correttamente.";
          this.errorMessageClass = "info";
          this.setProfileType(profile);
          this.profileForm.reset(profile);
          this.loadDocuments(profile);

          var that = this;

          setTimeout(function () {
            that.error = "no_error";
            that.errorMessageClass = "alert";
          }, 4000);
        }
      })
      .catch((_error) => {
        this.error = "Impossibile salvare il profilo.";
        this.loading = false;
      });
  }

  setProfileType(profile: Profile) {
    if (profile.privateRegistry == true) {
      this.privateRegistry = true;
      profile.designer = null;
      this.changeFormValidatorsPrivateRegistry()
    }
  }

  resetError() {
    this.error = "no_error";
    this.errorMessageClass = "alert";
  }

  uploadDocument(document: Document, event: { target: { files: any[] } }) {
    let files = event.target.files;
    let file = files[0];
    if (files && file) {
      const reader = new FileReader();
      document.document = {};
      document.document.fileName = file.name;
      document.document.mimeType = file.type;
      reader.onload = (readerEvt: { target: { result: any } }) => {
        return this.handleReaderLoaded(document, readerEvt);
      };
      reader.readAsBinaryString(file);
      document.message = file.name;
    }
  }

  uploadLogo(event: { target: { files: any[] } }) {
    this.uploadDocument(this.logo, event);
  }

  uploadVisura(event: { target: { files: any[] } }) {
    this.uploadDocument(this.visura, event);
  }

  uploadDurc(event: { target: { files: any[] } }) {
    this.uploadDocument(this.durc, event);
  }

  handleReaderLoaded(
    document: Document,
    readerEvt: { target: { result: any } }
  ) {
    let binaryString = readerEvt.target.result;
    let base64textString = btoa(binaryString);
    document.document.base64Content = base64textString;
  }

  goToDocumentUrl(document: Document) {
    if (document.document && document.document.documentUrl) {
      window.open(document.document.documentUrl, "_blank");
    }
  }

  goToLogoUrl() {
    this.goToDocumentUrl(this.logo);
  }

  goToVisuraUrl() {
    this.goToDocumentUrl(this.visura);
  }

  goToDurcUrl() {
    this.goToDocumentUrl(this.durc);
  }

  copyLegalOfficeData() {
    this.profileForm.controls["operationalCity"].setValue(
      this.profileForm.controls["city"].value
    );
    this.profileForm.controls["operationalProvinceCode"].setValue(
      this.profileForm.controls["provinceCode"].value
    );
    this.profileForm.controls["operationalZipCode"].setValue(
      this.profileForm.controls["zipCode"].value
    );
    this.profileForm.controls["operationalAddress"].setValue(
      this.profileForm.controls["address"].value
    );
    this.profileForm.controls["operationalAddressNumber"].setValue(
      this.profileForm.controls["addressNumber"].value
    );
  }

  addSpecialization() {
    let spec: Specialization = {
      id: null,
      code: null,
      salesPrice: null,
      minPrice: null,
      maxPrice: null,
      minAmount: null,
      notificationEnabled: true,
    };
    let specUM: SpecializationUM = {
      specialization: spec,
      um: null,
      errorMessage: null,
    };
    this.specializations.push(specUM);
    this.setSpecializationAddButtonVisibility();
  }

  addSector() {
    this.sectorCodes.push({ sector: null });
    this.setSectorAddButtonVisibility();
  }

  addReference() {
    let reference: Reference = { id: null, name: null };
    let refer: Refer = { reference: reference, errorMessage: null };
    this.references.push(refer);
    this.setReferenceAddButtonVisibility();
  }

  setRefer(refer: Refer) {
    if (
      this.references.filter(
        (item) => item.reference.name === refer.reference.name
      ).length > 1
    ) {
      refer.errorMessage =
        "Questa referenza esiste già. Aggiungine una diversa.";
      return;
    }
  }

  removeReference(reference: Reference) {
    this.references = this.references.filter((item) => item !== reference);
    this.setReferenceAddButtonVisibility();
  }
  // section certification
  addCertification() {
    let certification: Certification = { id: null, name: null };
    let certif: Certif = { certification: certification, errorMessage: null };
    this.certifications.push(certif);
  }

  setCertif(certif: Certif) {
    if (
      this.certifications.filter(
        (item) => item.certification.name === certif.certification.name
      ).length > 1
    ) {
      certif.errorMessage =
        "Questa certificazione esiste già. Aggiungine una diversa.";
      return;
    }
  }

  removeCertification(certification: Certification) {
    this.certifications = this.certifications.filter(
      (item) => item !== certification
    );
  }
  //////////////////////////////////////////////////

  // start section certificate (attestati)

  addCertificate() {
    let certificate: Certificate = { id: null, name: null };
    let certificatesItem: CertificatesItem = {
      certificate,
      errorMessage: null,
    };
    this.certificates.push(certificatesItem);
  }

  setCertificatesItem(certificatesItem: CertificatesItem) {
    if (
      this.certificates.filter(
        (item) => item.certificate.name === certificatesItem.certificate.name
      ).length > 1
    ) {
      certificatesItem.errorMessage =
        "Questo attestato esiste già. Aggiungine una diverso.";
      return;
    }
  }

  removeCertificate(certificate: Certificate) {
    this.certificates = this.certificates.filter(
      (item) => item !== certificate
    );
  }

  // end section certificate (attestati)

  setSpecializationUM(specializationUM: SpecializationUM) {
    if (
      this.specializations.filter(
        (item) =>
          item.specialization.code === specializationUM.specialization.code
      ).length > 1
    ) {
      specializationUM.errorMessage =
        "Questa specializzazione esiste già. Aggiungine una diversa.";
      return;
    }

    if (!this.checkDesigner.nativeElement.checked) {
      specializationUM.um = this.specializationsCompanyList.filter(
        (item) => item.code === specializationUM.specialization.code
      )[0].measurementUnit;
    } else if (this.checkDesigner.nativeElement.checked) {
      specializationUM.um = this.specializationsProfessionalList.filter(
        (item) => item.code === specializationUM.specialization.code
      )[0].measurementUnit;
    }

    this.resetSpecError(specializationUM);
  }

  removeSpecialization(specializationUM: SpecializationUM) {
    this.specializations = this.specializations.filter(
      (item) => item !== specializationUM
    );
    this.setSpecializationAddButtonVisibility();
  }

  removeSector(sector) {
    this.sectorCodes = this.sectorCodes.filter(
      (item) => item.sector !== sector.sector
    );
    this.setSectorAddButtonVisibility();
  }

  setSpecializationAddButtonVisibility() {
    if (this.userCompany) {
      this.addSpecializationButtonVisible = this.specializations.length < 3;
    }
  }
  ///////////////////////////////
  setReferenceAddButtonVisibility() {
    this.addReferenceButtonVisible = this.references.length < 3;
  }

  setSectorAddButtonVisibility() {
    this.addSectorButtonVisible = this.sectorCodes.length < 3;
  }

  deleteSpecializations() {
    this.specializations = [];
    this.setSpecializationAddButtonVisibility();
  }

  switchUserType() {
    this.userCompany = this.showhidedesigner;
    if (this.privateRegistry == true) {
      this.resetFields();
    }
    this.privateRegistry = false;
    this.changeFormValidatorsDesignerBusiness()
  }

  changeToPrivateRegistry() {
    this.showhidedesigner = null;
    this.privateRegistry = true;
    this.profileForm.patchValue({ sdiCode: "0000000" });
     this.changeFormValidatorsPrivateRegistry()
  }

  changeFormValidatorsDesignerBusiness(){
    this.profileForm.controls["companyName"].setValidators(Validators.required);
    this.profileForm.controls["companyName"].updateValueAndValidity();
    this.profileForm.setValidators([AlmostOneRequired("vatCode", "fiscalCode"),
    AlmostOneRequired("sdiCode", "pec")])
    this.profileForm.controls['sdiCode'].enable()
  }

  changeFormValidatorsPrivateRegistry() {
    this.profileForm.controls["companyName"].clearValidators();
    this.profileForm.controls["companyName"].updateValueAndValidity();
    this.profileForm.controls["vatCode"].clearValidators();
    this.profileForm.controls["vatCode"].updateValueAndValidity();
    this.profileForm.controls["sdiCode"].clearValidators();
    this.profileForm.controls["sdiCode"].updateValueAndValidity();
    this.profileForm.controls["fiscalCode"].clearValidators();
    this.profileForm.controls["fiscalCode"].updateValueAndValidity();
    this.profileForm.controls["pec"].clearValidators();
    this.profileForm.controls["pec"].updateValueAndValidity();

    this.profileForm.controls["pec"].setValidators(Validators.pattern(CommonService.EMAIL_REGEXP))
    this.profileForm.controls['sdiCode'].disable()
    this.profileForm.clearValidators()
    this.profileForm.updateValueAndValidity()
  }

  scrollToComponent(componentId) {
    let invalidElement: HTMLElement = document.getElementById(componentId);
    // if (invalidElement) {
    //   invalidElement.focus();
    // }
    this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
      invalidElement
    );
  }

  scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement =
      this.el.nativeElement.querySelector("form .ng-invalid");
    // if (firstInvalidControl) {
    //   firstInvalidControl.focus();
    // }
    this.invalidControlScrollDirective.manualScrollToFirstInvalidElementRef(
      firstInvalidControl
    );
  }
}
